import {Checkbox, Form, Input, InputNumber, Select} from 'antd';
import sorters from "../../util/sorters";
import TextArea from "antd/es/input/TextArea";

export const buildTextInput = field => {
  return (
    <Form.Item key={field.field} label={field.title} name={field.field}
               rules={field.rules ? field.rules : [{required: field.required}]}>
      <Input/>
    </Form.Item>
  );
};

export const buildTextArea = field => {
  return (
    <Form.Item key={field.field} label={field.title} name={field.field}
      rules={field.rules ? field.rules : [{required: field.required}]}>
      <TextArea/>
    </Form.Item>
  );
};

export const buildNumberInput = field => {
  return (
    <Form.Item key={field.field} label={field.title} name={field.field}
               rules={field.rules ? field.rules : [{required: field.required}]}>
      <InputNumber max={field.number_max} min={field.number_min}/>
    </Form.Item>
  );
};

export const buildCheckboxInput = field => {
  return (
    <Form.Item key={field.field} label={field.title} name={field.field} valuePropName="checked">
      <Checkbox/>
    </Form.Item>
  );
};

export const buildSelectInput = (field, multi) => {
  return (
    <Form.Item key={field.field} label={field.title} name={field.field}
               rules={field.rules ? field.rules : [{required: true}]}>
      <Select mode={multi ? 'multiple' : ''} placeholder={`Select option${multi ? '(s)' : ''}`}>
        {field.options.map(r => (<Select.Option key={r} value={r}>
          {r}
        </Select.Option>))}
      </Select>
    </Form.Item>
  );
};

export const buildMappingSelectInput = (mappingData, field, psa_instance) => {
  let options;

  if (field.dataFrom) {
    options = mappingData[field.dataFrom];
  } else {
    options = mappingData[field.field];
  }
  if (psa_instance) {
    options = options.filter(o => o.PsaInstance === psa_instance);
  }
  return (<Form.Item key={field.field} label={field.title} name={field.field} rules={[{required: field.required}]}>
    <Select
      showSearch
      allowClear={!field.required}
      mode={field.multi ? 'multiple' : ''}
      placeholder={`Select option${field.multi ? '(s)' : ''}`}
      optionFilterProp="children"
      filterOption={(input, option) =>
        option.label.toLocaleLowerCase().indexOf(input.toLocaleLowerCase()) >= 0}
      filterSort={(a, b) =>
        (sorters.string(a.label, b.label))
      }
      options={options.map(r => ({
          value: r[field.optionValue],
          label: r[field.optionLabel]
        }))}/>
  </Form.Item>);
};
